<template>
  <div class="template-padding">
    <div class="row">
      <div class="col col-sm-10">
        <h4 class="font-weight-bolder">
          TRAINING CENTER LIST
        </h4>
      </div>
      <div class="col col-sm-2 text-right">
        <router-link
          to="/trainingCenter/create"
          class="btn btn-sm btn-outline-primary font-weight-bolder  mr-4"
          title="ADD NEW TRAINING CENTER"
          tag="button"
        >
          <span><i class="fas fa-plus" /></span>
          ADD NEW
        </router-link>
      </div>
    </div>

    <table class="table table-hover table-bordered">
      <thead>
        <tr class="table-header">
          <th class="p-1">
            #
          </th>
          <th class="p-1">
            CODE
          </th>
          <th class="p-1">
            NAME
          </th>
          <th class="p-1">
            EMAIL
          </th>
          <th class="p-1">
            CONTACT NUMBER
          </th>
          <th class="p-1">
            CONTACT PERSON
          </th>
          <th class="p-1">
            STATUS
          </th>
          <th class="col-actions p-1">
            ACTION
          </th>
        </tr>
      </thead>
      <tbody>
        `
        <tr
          v-for="(trainingCenter, index) in trainingCenters"
          :key="trainingCenter.id"
          :class="{'inactive': !trainingCenter.status}"
        >
          <td class="p-1">
            {{ index + 1 }}
          </td>
          <td class="p-1">
            {{ trainingCenter.code }}
          </td>
          <td class="p-1">
            {{ trainingCenter.name }}
          </td>
          <td class="p-1">
            {{ trainingCenter.email }}
          </td>
          <td class="p-1">
            {{ trainingCenter.contact_number }}
          </td>
          <td class="p-1">
            {{ trainingCenter.contact_person }}
          </td>
          <td class="p-1">
            {{ trainingCenter.status | setStatus }}
          </td>
          <td class="p-1">
            <button
              class="btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder"
              :title="`VIEW ${trainingCenter.code} RECORD`"
              @click="viewTrainingCenter(trainingCenter.id)"
            >
              <span><i class="fas fa-eye" /></span>
              View
            </button>
            <button
              class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder"
              :title="`DELETE ${trainingCenter.code} RECORD`"
              @click="removeTrainingCenter(trainingCenter.id)"
            >
              <span><i class="fas fa-trash" /></span>
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from "../../../mixins/formMixins";

    export default {
        mixins: [ formMixins ],
        name: 'IndexTrainingcCenter',
        methods: {
            ...mapActions([ 'getTrainingCenters', 'deleteTrainingCenter' ]),
            viewTrainingCenter(id) {
                this.$router.push(`/trainingCenter/${id}`);
            },
            async removeTrainingCenter(id) {
                if(await this.deleteAlert('Are you sure you want to delete this record?')) {
                    if(await this.deleteTrainingCenter(id)) {
                        this.successAlert('Training Center Successfully Deleted!', 'DELETE');
                    } else {
                        this.errorAlert('Training Center Failed to Delete', 'DELETE');
                    }
                }
            }
        },
        computed: {
            ...mapGetters([ 'trainingCenters' ])
        },
        created() {
            this.getTrainingCenters();
        }
    };
</script>

<style scoped>

</style>
